export interface VideoItem {
  id: string;
  title: string;
  description: string;
  thumbnail: string;
  category: string;
  categorySlug: string;
  author: string;
  authorAvatar: string;
  views: number;
  likes: number;
  duration: string;
  date: string;
  content: string;
  tags: string[];
}

export interface CategoryItem {
  name: string;
  slug: string;
  icon: string;
  count: number;
  description: string;
}

export interface CreatorItem {
  name: string;
  avatar: string;
  followers: number;
  videos: number;
  description: string;
  verified: boolean;
}

export interface ReviewItem {
  name: string;
  avatar: string;
  rating: number;
  content: string;
  date: string;
}

export const categories: CategoryItem[] = [
  { name: '舞蹈', slug: 'dance', icon: 'ri-music-2-line', count: 12850, description: '热门舞蹈视频，潮流舞步尽在掌握' },
  { name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line', count: 25630, description: '爆笑段子合集，每天欢乐不断' },
  { name: '美食', slug: 'food', icon: 'ri-restaurant-line', count: 9840, description: '美食制作教程，舌尖上的诱惑' },
  { name: '旅行', slug: 'travel', icon: 'ri-flight-takeoff-line', count: 7230, description: '旅行Vlog，带你走遍世界角落' },
  { name: '音乐', slug: 'music', icon: 'ri-music-line', count: 15620, description: '热门歌曲翻唱，原创音乐分享' },
  { name: '时尚', slug: 'fashion', icon: 'ri-shirt-line', count: 8910, description: '时尚穿搭分享，潮流趋势解读' },
  { name: '游戏', slug: 'gaming', icon: 'ri-gamepad-line', count: 11240, description: '热门游戏实况，精彩操作集锦' },
  { name: '知识', slug: 'knowledge', icon: 'ri-book-open-line', count: 6450, description: '科普知识分享，学习不再枯燥' },
];

export const videos: VideoItem[] = [
  {
    id: 'v001',
    title: '这支舞太帅了！全网都在学的热门编舞教程',
    description: '最近爆火的全网编舞挑战来了！零基础也能学会，跟着节奏一起动起来，让你成为朋友圈最靓的仔。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20dynamic%20dance%20studio%20scene%20with%20dancer%20in%20mid%20motion%20wearing%20streetwear%20under%20neon%20lighting%2C%20energetic%20and%20modern%20aesthetic%2C%20urban%20dance%20vibe%2C%20professional%20lighting%20setup%2C%20vibrant%20warm%20orange%20and%20pink%20tones&width=800&height=600&seq=dance-video-001&orientation=landscape',
    category: '舞蹈',
    categorySlug: 'dance',
    author: '舞动青春',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20female%20dancer%20portrait%20in%20studio%20lighting%2C%20warm%20tones%2C%20modern%20aesthetic%2C%20clean%20background%2C%20professional%20headshot%20style&width=200&height=200&seq=avatar-dancer-01&orientation=squarish',
    views: 1280000,
    likes: 98500,
    duration: '01:24',
    date: '2026-08-05',
    content: '<p>最近爆火的全网编舞挑战来了！这支舞蹈融合了街舞与流行舞的元素，节奏感十足，动作帅气利落。无论你是舞蹈达人还是零基础新手，跟着教程一步步来，保证你能在短时间内掌握要领。</p><p>教程分为三个部分：基础动作分解、节奏感练习、完整动作串联。每个动作都有慢速演示和讲解，让你轻松跟上节奏。</p><p>💡 学习小贴士：先看完整版感受节奏，再跟着分解动作练习，最后尝试完整版。记得多练几遍，熟能生巧！</p>',
    tags: ['编舞', '热门舞蹈', '教程', '街舞', '流行舞'],
  },
  {
    id: 'v002',
    title: '笑到肚子疼！2026年度最搞笑的街头采访合集',
    description: '走上街头随机采访，路人的神回复让人笑到停不下来，每一段都是快乐源泉。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20funny%20street%20interview%20scene%20in%20a%20bustling%20Chinese%20city%2C%20warm%20sunlight%2C%20casual%20vibe%2C%20people%20laughing%20naturally%2C%20urban%20street%20background%2C%20vibrant%20and%20lively%20atmosphere&width=800&height=600&seq=comedy-video-002&orientation=landscape',
    category: '搞笑',
    categorySlug: 'comedy',
    author: '开心一刻',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20with%20friendly%20smile%20in%20casual%20outfit%2C%20outdoor%20natural%20light%2C%20warm%20tones%2C%20clean%20portrait%20photography&width=200&height=200&seq=avatar-comedy-01&orientation=squarish',
    views: 2560000,
    likes: 186000,
    duration: '03:12',
    date: '2026-08-04',
    content: '<p>我们又上街了！这次的问题是："如果你有一百万，你会怎么花？"路人们的回答简直太精彩了，有人要买下一整条小吃街，有人说要辞职环游世界，还有人说......先还花呗！</p><p>本期街头采访走过了五个城市的热门商圈，收集了超过100位路人的回答。我们精选了其中最搞笑、最真实、最意想不到的30个回答，保证让你笑得停不下来。</p><p>在评论区告诉我们：如果你有一百万，你会怎么花？抽三位点赞最高的评论送出小礼物！</p>',
    tags: ['街头采访', '搞笑', '路人神回复', '搞笑合集'],
  },
  {
    id: 'v003',
    title: '深夜放毒！教你做一口爆汁的黄金脆皮炸鸡',
    description: '外酥里嫩、一口爆汁的完美炸鸡配方大公开，学会了你也能开炸鸡店。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Golden%20crispy%20fried%20chicken%20on%20a%20wooden%20board%2C%20juicy%20inside%20texture%2C%20steam%20rising%2C%20warm%20kitchen%20lighting%2C%20rustic%20aesthetic%2C%20food%20photography%20with%20natural%20light%20from%20window&width=800&height=600&seq=food-video-003&orientation=landscape',
    category: '美食',
    categorySlug: 'food',
    author: '厨房小能手',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20chef%20in%20apron%20in%20bright%20kitchen%2C%20warm%20smile%2C%20natural%20lighting%2C%20clean%20professional%20portrait&width=200&height=200&seq=avatar-chef-01&orientation=squarish',
    views: 985000,
    likes: 78500,
    duration: '02:48',
    date: '2026-08-03',
    content: '<p>今天教大家做一个超好吃的黄金脆皮炸鸡！这个配方是我研究了大半年才最终确定的，外皮金黄酥脆，内里鲜嫩多汁，咬一口汁水四溢，简直绝了！</p><p>关键步骤：1）鸡肉要提前腌制至少4小时；2）裹粉要三次循环（面粉→蛋液→面粉）；3）油温控制在170度，炸8分钟刚刚好。每个步骤都不能偷懒哦！</p><p>配上自制的蜂蜜芥末酱或者番茄酱，好吃到舔手指！赶快收藏起来，周末就试试吧～</p>',
    tags: ['美食教程', '炸鸡', '家常菜', '深夜放毒', '食谱'],
  },
  {
    id: 'v004',
    title: '云南秘境之旅：99%的人都不知道的宝藏目的地',
    description: '避开人潮，发现云南那些鲜为人知的绝美秘境，每一帧都是壁纸。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20hidden%20landscape%20in%20Yunnan%20China%20with%20terraced%20fields%20and%20morning%20mist%2C%20golden%20hour%20sunlight%2C%20peaceful%20village%20in%20distance%2C%20lush%20green%20mountains%2C%20travel%20photography%20aesthetic&width=800&height=600&seq=travel-video-004&orientation=landscape',
    category: '旅行',
    categorySlug: 'travel',
    author: '在路上',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20traveler%20with%20backpack%20in%20nature%2C%20warm%20sunset%20light%2C%20adventure%20vibe%2C%20clean%20portrait%20style&width=200&height=200&seq=avatar-travel-01&orientation=squarish',
    views: 752000,
    likes: 62100,
    duration: '04:05',
    date: '2026-08-02',
    content: '<p>想去云南旅行但不想人挤人？这份秘境攻略请收好！我花了一个月时间探访了云南6个鲜为人知的绝美目的地，每一个都美到让人窒息。</p><p>从泸沽湖畔的隐秘村落，到香格里拉深处的雪山草甸；从元阳梯田的日出云海，到腾冲银杏村的满地金黄。这些地方不仅游客少，而且风景丝毫不输热门景点。</p><p>每个目的地都附上了交通攻略、住宿推荐和最佳游览时间，跟着攻略走就对了！</p>',
    tags: ['旅行攻略', '云南', '秘境', '自由行', '摄影'],
  },
  {
    id: 'v005',
    title: '开口跪！素人翻唱《起风了》惊艳全网',
    description: '街边偶遇的素人歌手，一开口就让路人纷纷停下脚步，这嗓音太治愈了。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Street%20musician%20performing%20with%20guitar%20in%20a%20warm%20evening%20urban%20setting%2C%20soft%20golden%20sunset%20light%2C%20crowd%20gathered%20around%2C%20emotional%20and%20atmospheric%20mood&width=800&height=600&seq=music-video-005&orientation=landscape',
    category: '音乐',
    categorySlug: 'music',
    author: '音乐捕手',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20musician%20with%20headphones%20in%20recording%20studio%2C%20soft%20ambient%20lighting%2C%20warm%20tones%2C%20professional%20music%20portrait&width=200&height=200&seq=avatar-music-01&orientation=squarish',
    views: 1890000,
    likes: 152000,
    duration: '02:15',
    date: '2026-08-01',
    content: '<p>在成都太古里的街头偶遇了这位小姐姐，她正在街头弹唱。一开始只是几个路人驻足，但当《起风了》的旋律响起时，整条街的人都停下了脚步。</p><p>她的嗓音有一种特别的质感，温柔中带着力量，高音部分游刃有余，情感表达恰到好处。现场很多人听完都说被治愈了。</p><p>关注我们，带你发现更多隐藏在街头巷尾的音乐宝藏～</p>',
    tags: ['翻唱', '起风了', '街头音乐', '素人歌手', '治愈'],
  },
  {
    id: 'v006',
    title: '夏季穿搭指南：三件基础单品搞定一周不重样',
    description: '极简衣橱也能穿出高级感，用最少单品搭出最多风格，懒人必备穿搭公式。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Minimalist%20fashion%20flat%20lay%20with%20summer%20clothing%20items%20on%20light%20wooden%20floor%2C%20neutral%20warm%20tones%2C%20clean%20aesthetic%2C%20natural%20sunlight%2C%20fashion%20blogger%20style%20photography&width=800&height=600&seq=fashion-video-006&orientation=landscape',
    category: '时尚',
    categorySlug: 'fashion',
    author: '穿搭日记',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20fashion%20blogger%20in%20minimalist%20outfit%2C%20warm%20natural%20lighting%2C%20clean%20portrait%2C%20modern%20urban%20style&width=200&height=200&seq=avatar-fashion-01&orientation=squarish',
    views: 678000,
    likes: 43500,
    duration: '01:56',
    date: '2026-07-31',
    content: '<p>夏天到了，衣柜又要爆炸了？别急！今天教你用三件基础单品搞定一周穿搭，省钱又省心。</p><p>核心单品：一件白T恤、一条高腰阔腿裤、一件薄款西装外套。这三件单品可以搭配出至少7套不同风格的look，从通勤到约会全部搞定。</p><p>每套搭配都有详细的搭配思路和配饰建议，让你的基础款也能穿出高级感。懒人必备，赶紧收藏！</p>',
    tags: ['穿搭', '夏季', '极简', '时尚', '懒人穿搭'],
  },
  {
    id: 'v007',
    title: '王者荣耀S35赛季：新英雄玩法深度解析',
    description: '新英雄上线后胜率飙升，这份最全攻略让你轻松上分，技能连招一看就会。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20gaming%20scene%20with%20hero%20character%20in%20action%20pose%2C%20dramatic%20lighting%2C%20fantasy%20battle%20background%2C%20dynamic%20composition%2C%20warm%20orange%20and%20gold%20accents&width=800&height=600&seq=gaming-video-007&orientation=landscape',
    category: '游戏',
    categorySlug: 'gaming',
    author: '游戏达人Pro',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20gamer%20with%20headset%2C%20esports%20vibe%2C%20RGB%20lighting%20in%20background%2C%20professional%20gaming%20portrait&width=200&height=200&seq=avatar-gaming-01&orientation=squarish',
    views: 1560000,
    likes: 125000,
    duration: '05:30',
    date: '2026-07-30',
    content: '<p>S35赛季新英雄已经上线一周了！经过大量实战测试，我整理了一份最全面的玩法攻略，包括技能解析、连招技巧、出装推荐和实战思路。</p><p>这个英雄的机制很特别，操作上限极高，但入门门槛并不高。掌握核心连招后，在排位赛中能发挥出惊人的效果。我目前的胜率已经达到了78%。</p><p>攻略中包含了针对不同阵容的应对策略，以及与其他英雄的配合技巧。认真看完，上分不是梦！</p>',
    tags: ['王者荣耀', '新英雄', '攻略', '上分', '游戏教程'],
  },
  {
    id: 'v008',
    title: '3分钟搞懂量子计算：比你想象的简单多了',
    description: '用最通俗的方式讲解量子计算原理，没有复杂的公式，看完你也能跟朋友聊量子。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20quantum%20computing%20visualization%20with%20glowing%20particles%20and%20circuits%2C%20warm%20orange%20and%20gold%20light%20trails%2C%20clean%20modern%20tech%20aesthetic%2C%20educational%20science%20visual&width=800&height=600&seq=knowledge-video-008&orientation=landscape',
    category: '知识',
    categorySlug: 'knowledge',
    author: '科学有意思',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Chinese%20science%20educator%20with%20glasses%20in%20modern%20lab%20setting%2C%20friendly%20smile%2C%20warm%20lighting%2C%20professional%20portrait&width=200&height=200&seq=avatar-science-01&orientation=squarish',
    views: 523000,
    likes: 41200,
    duration: '03:20',
    date: '2026-07-29',
    content: '<p>量子计算听起来很高深，但其实核心概念非常有趣！今天我用最简单的比喻，让你3分钟搞懂量子计算是什么。</p><p>想象一下：传统计算机就像是一个硬币，一次只能显示正面或反面。而量子计算机就像是一个旋转的硬币，可以同时显示正面和反面的信息。这就是"叠加态"。</p><p>不需要任何物理基础，我们用日常生活中的例子来理解量子比特、量子纠缠和量子加速。相信我，看完你会发现原来量子计算这么有意思！</p>',
    tags: ['量子计算', '科普', '科技', '通俗易懂', '知识分享'],
  },
];

export const creators: CreatorItem[] = [
  { name: '舞动青春', avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20female%20dancer%20in%20studio%2C%20warm%20lighting%2C%20professional%20dance%20portrait%2C%20clean%20background&width=200&height=200&seq=creator-avatar-01&orientation=squarish', followers: 5200000, videos: 486, description: '专业舞者，街舞/编舞达人', verified: true },
  { name: '开心一刻', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20comedian%20with%20expressive%20face%2C%20bright%20studio%20lighting%2C%20fun%20portrait%2C%20clean%20background&width=200&height=200&seq=creator-avatar-02&orientation=squarish', followers: 3800000, videos: 312, description: '搞笑内容创作者，每日更新', verified: true },
  { name: '厨房小能手', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20female%20chef%20holding%20fresh%20ingredients%2C%20bright%20kitchen%2C%20warm%20natural%20light%2C%20clean%20portrait&width=200&height=200&seq=creator-avatar-03&orientation=squarish', followers: 2100000, videos: 528, description: '美食博主，家常菜教学', verified: true },
  { name: '在路上', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20male%20traveler%20with%20camera%20in%20nature%2C%20warm%20sunset%20light%2C%20adventure%20portrait%2C%20clean%20background&width=200&height=200&seq=creator-avatar-04&orientation=squarish', followers: 1800000, videos: 245, description: '旅行Vlogger，足迹遍布50国', verified: true },
  { name: '音乐捕手', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20musician%20playing%20guitar%2C%20moody%20studio%20lighting%2C%20artistic%20portrait%2C%20clean%20background&width=200&height=200&seq=creator-avatar-05&orientation=squarish', followers: 1500000, videos: 198, description: '音乐制作人，挖掘好声音', verified: false },
  { name: '穿搭日记', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20fashion%20influencer%20in%20stylish%20outfit%2C%20urban%20street%20background%2C%20warm%20lighting%2C%20clean%20fashion%20portrait&width=200&height=200&seq=creator-avatar-06&orientation=squarish', followers: 2800000, videos: 367, description: '时尚博主，穿搭灵感分享', verified: true },
  { name: '游戏达人Pro', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20esports%20player%20in%20gaming%20setup%2C%20RGB%20lighting%20background%2C%20professional%20gaming%20portrait&width=200&height=200&seq=creator-avatar-07&orientation=squarish', followers: 4200000, videos: 623, description: '职业电竞选手，技术流教学', verified: true },
  { name: '科学有意思', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20science%20communicator%20with%20lab%20equipment%2C%20bright%20modern%20setting%2C%20warm%20portrait%2C%20clean%20background&width=200&height=200&seq=creator-avatar-08&orientation=squarish', followers: 960000, videos: 156, description: '科普创作者，让科学变有趣', verified: true },
];

export const reviews: ReviewItem[] = [
  { name: '小明同学', avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20with%20warm%20smile%2C%20casual%20outdoor%20setting%2C%20natural%20light%2C%20clean%20portrait&width=200&height=200&seq=review-avatar-01&orientation=squarish', rating: 5, content: '91抖音是我每天必刷的平台！内容质量很高，推荐算法也很准，总能刷到我感兴趣的内容。达人创作的内容真的很用心。', date: '2026-08-01' },
  { name: '旅行爱好者', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20with%20camera%20in%20nature%2C%20warm%20sunlight%2C%20travel%20vibe%2C%20clean%20portrait&width=200&height=200&seq=review-avatar-02&orientation=squarish', rating: 5, content: '通过91抖音发现了超多宝藏旅行目的地！美食、旅行类的视频质量特别高，创作者们都很用心。', date: '2026-07-28' },
  { name: '程序员老张', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20in%20tech%20office%2C%20friendly%20professional%20look%2C%20warm%20lighting%2C%20clean%20portrait&width=200&height=200&seq=review-avatar-03&orientation=squarish', rating: 5, content: '平时工作压力大，喜欢刷搞笑视频放松。91抖音的搞笑内容真的太解压了，每次都能笑到肚子疼。', date: '2026-07-25' },
  { name: '大学生小美', avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20female%20college%20student%20on%20campus%2C%20bright%20daylight%2C%20friendly%20smile%2C%20clean%20portrait&width=200&height=200&seq=review-avatar-04&orientation=squarish', rating: 4, content: '跟着91抖音学到了好多实用技能！舞蹈教程、穿搭技巧都很实用。希望以后能有更多知识类的内容。', date: '2026-07-22' },
  { name: '退休教师王阿姨', avatar: 'https://readdy.ai/api/search-image?query=Chinese%20elderly%20woman%20with%20kind%20smile%2C%20warm%20home%20setting%2C%20natural%20light%2C%20clean%20portrait&width=200&height=200&seq=review-avatar-05&orientation=squarish', rating: 5, content: '女儿教我用91抖音之后，每天都离不开！美食教程简单易懂，我学会了做好多新菜，家人都说好吃。', date: '2026-07-20' },
];

export const aboutInfo = {
  brandName: '91抖音',
  slogan: '记录美好，分享快乐',
  founded: '2018年',
  users: '超过5亿',
  dailyActive: '日均活跃用户超过8000万',
  introduction: '91抖音是中国领先的短视频娱乐平台，致力于通过短视频内容连接人与人、人与世界。自2018年成立以来，91抖音始终秉持"记录美好，分享快乐"的理念，为用户打造了一个充满创造力与正能量的内容社区。',
  mission: '我们的使命是让每个人都能通过短视频表达自我、发现世界。无论是专业创作者还是普通用户，都能在91抖音找到属于自己的舞台。平台汇聚了来自全国各地的优秀内容创作者，覆盖舞蹈、搞笑、美食、旅行、音乐、时尚、游戏、知识等数十个领域，日均新增短视频内容超过1000万条。',
  vision: '我们致力于成为全球最具影响力的短视频内容平台，通过技术创新和内容生态建设，持续为用户提供更优质、更多元的内容体验。未来，91抖音将继续加大在AI推荐、内容审核、创作者扶持等方面的投入，打造更健康、更有活力的内容社区。',
  values: [
    { title: '用户至上', description: '始终将用户体验放在首位，持续优化产品功能与内容质量。' },
    { title: '内容为王', description: '坚持以优质内容为核心驱动力，支持创作者持续产出高质量作品。' },
    { title: '技术创新', description: '持续投入AI、大数据等技术研发，打造更智能的内容分发系统。' },
    { title: '社会责任', description: '积极履行平台责任，传播正能量，守护清朗网络空间。' },
  ],
  contact: {
    email: 'contact@91douyin.com',
    phone: '400-888-9191',
    address: '北京市海淀区中关村科技园区',
    wechat: '91抖音官方',
    weibo: '@91抖音官方',
  },
};

export const faqs = [
  { question: '91抖音如何注册账号？', answer: '您可以通过手机号、微信或QQ账号快速注册91抖音。打开91抖音APP或访问官网，点击"注册"按钮，按照提示填写信息即可完成注册，整个过程只需1分钟。' },
  { question: '91抖音支持哪些设备？', answer: '91抖音支持iOS和Android手机、平板电脑以及网页版。您可以在App Store或各大应用商店搜索"91抖音"下载，也可以直接通过浏览器访问我们的官网使用网页版。' },
  { question: '如何在91抖音上发布视频？', answer: '登录账号后，点击底部"+"按钮，选择拍摄或从相册上传视频。您可以为视频添加音乐、滤镜、特效等，编辑完成后添加描述和标签即可发布。' },
  { question: '91抖音的视频可以下载吗？', answer: '部分视频支持下载到本地，具体取决于创作者的设置。如果创作者开启了下载权限，您可以在视频页面找到下载按钮。请注意尊重创作者的版权。' },
  { question: '如何成为91抖音的认证达人？', answer: '当您的粉丝数达到一定数量且内容质量符合平台标准后，可以在设置中申请达人认证。平台会综合评估您的账号活跃度、内容质量和粉丝互动情况后进行审核。' },
  { question: '91抖音如何处理用户隐私？', answer: '我们高度重视用户隐私保护，严格遵守相关法律法规。所有用户数据均经过加密处理，未经用户授权不会向第三方提供。详情请查看我们的隐私政策。' },
];